<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__grid">
        <!-- 带二级分组的列（AI业务 / 云服务） -->
        <div class="site-footer__col" v-for="group in groupedColumns" :key="group.title">
          <h3 class="site-footer__title">{{ group.title }}</h3>
          <div class="site-footer__subgroup" v-for="sub in group.subgroups" :key="sub.title">
            <div class="site-footer__subtitle">{{ sub.title }}</div>
            <ul class="site-footer__list">
              <li v-for="link in sub.links" :key="link.label">
                <a v-if="link.href" class="site-footer__link" :href="link.href" target="_blank"
                  rel="noopener noreferrer">{{ link.label }}</a>
                <router-link v-else class="site-footer__link" :to="link.to" target="_blank">{{ link.label }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 单层链接列（机器人 / 关于我们） -->
        <div class="site-footer__col" v-for="group in flatColumns" :key="group.title">
          <h3 class="site-footer__title">{{ group.title }}</h3>
          <ul class="site-footer__list">
            <li v-for="link in group.links" :key="link.label">
              <router-link class="site-footer__link" :to="link.to" target="_blank">{{ link.label }}</router-link>
            </li>
          </ul>
        </div>

        <!-- 联系我们 + 二维码 -->
        <div class="site-footer__col site-footer__col--contact">
          <h3 class="site-footer__title">联系我们</h3>
          <div class="site-footer__contact">
            <div class="site-footer__contact-row">
              <span class="site-footer__contact-key">公司名称：</span>汇通数科智能科技有限公司
            </div>
            <div class="site-footer__contact-row">
              <span class="site-footer__contact-key">联系地址：</span>江苏省南京市玄武区钟灵街50号汇通达大厦C座
            </div>
            <div class="site-footer__contact-row site-footer__contact-row--tel">
              <span class="site-footer__contact-key">联系电话：</span>
              <span class="site-footer__tel">400-639-9988</span>
            </div>
          </div>
          <div class="site-footer__qr">
            <div class="site-footer__qr-item">
              <img src="@/assets/qrcode1.jpg" alt="汇通达公众号">
              <p>汇通达公众号</p>
            </div>
            <div class="site-footer__qr-item">
              <img src="@/assets/qrcode2.jpg" alt="汇通数科公众号">
              <p>汇通数科公众号</p>
            </div>
          </div>
        </div>
      </div>

      <div class="site-footer__bottom">
        <a class="site-footer__bottom-left" href="https://www.htd.cn/" target="_blank" rel="noopener noreferrer">友情链接：汇通达</a>
        <div class="site-footer__bottom-right">
          <span>Copyright©2019-{{ year }} 汇通数科智能科技有限公司 版权所有</span>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010202011944" target="_blank"
            rel="noopener noreferrer">苏公网安备32010202011944号</a>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">苏ICP备20013617号</a>
          <a href="https://static.qcos.cn/htdt/mobileapp/htsk/license/license.jpg" target="_blank"
            rel="noopener noreferrer">营业执照</a>
          <a href="https://static.qcos.cn/htdt/mobileapp/htsk/license/business-license.jpg" target="_blank"
            rel="noopener noreferrer">增值电信业务经营许可证</a>
          <span>联系电话：400-639-9988</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/**
 * 结构与配色对齐 projects-vue 的 SiteFooter.vue：
 * 多列 grid + 二级小标题，链接由数据驱动。
 *
 * 注意：SiteFooter 里的「解决方案」列没有移植 —— 那 6 条 /solutions/* 在
 * website-shuke 里没有对应路由，所以这里是 5 列而不是 6 列。
 *
 * link 两种形态：
 *   { label, to }   → 站内路由，用 router-link
 *   { label, href } → 外链，用 a
 */
const groupedColumns = [
  {
    title: 'AI业务',
    subgroups: [
      {
        title: '企业智能体',
        links: [
          { label: '千橙AI超级店长', to: { name: 'qcSuper' } },
          { label: 'LeapoAI', to: { name: 'leapoAI' } },
          { label: '九词Token算力平台', to: { name: 'nineToken' } },
          // { label: 'AI生图', href: 'https://ai.qcos.cn/qcwxai/' },
          // { label: 'AI外呼', href: 'https://smart.htd.cn/user-center/#/login?clientId=voice_outbound_call' },
          // { label: '行业分析', href: 'https://ai.qcos.cn/qcwxai/' },
        ],
      },
      {
        title: '企业级数据服务',
        links: [{ label: '千智数据平台', to: { name: 'aiDataService' } }],
      },
      {
        title: '存算大模型一体机',
        links: [
          { label: '玄武系列', to: { name: 'aiServer', query: { series: 'xuanwu' } } },
          { label: '钟山系列', to: { name: 'aiServer', query: { series: 'zhongshan' } } },
        ],
      },
    ],
  },
  {
    title: '云服务',
    subgroups: [
      {
        title: '零售云',
        links: [
          { label: '千橙收银系统', to: { name: 'retailMall' } },
          { label: '千橙门店O2O系统', to: { name: 'onlineAndOfflineIntegration' } },
          { label: '千橙连锁系统', to: { name: 'onlineErp' } },
        ],
      },
      {
        title: '分销云',
        links: [
          { label: '千橙S2B2C系统', to: { name: 'integration' } },
          { label: '千橙B2B系统', to: { name: 'b2bChannel' } },
        ],
      },
      {
        title: '电商云',
        links: [
          { label: '千橙微商城', to: { name: 'digitalSystem' } },
          { label: '汇团团社群营销', to: { name: 'scrmProduct' } },
        ],
      },
      {
        title: '会员云',
        links: [{ label: '千橙会员营销', to: { name: 'marketing' } }],
      },
      {
        title: '直播云',
        links: [{ label: '千橙直播', to: { name: 'live' } }],
      },
    ],
  },
];

const flatColumns = [
  {
    title: '机器人',
    links: [
      { label: 'LM200 零售巡检机器人', to: { name: 'lm200' } },
      { label: 'LM201 健康巡检机器人', to: { name: 'lm201' } },
      { label: 'LM202 零售巡检机器人', to: { name: 'lm202' } },
      { label: 'LM203 安保巡逻机器人', to: { name: 'lm203' } },
      { label: 'LM211 零售机器人', to: { name: 'lm211' } },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '新闻发布', to: { name: 'news' } },
      { label: '关于我们', to: { name: 'about' } },
      { label: 'AI效果营销', to: { name: 'market' } },
      { label: '千橙AI合作伙伴计划', to: { name: 'coPlan' } },
    ],
  },
];

export default {
  data() {
    return {
      groupedColumns,
      flatColumns,
      year: new Date().getFullYear(),
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/components/siteVars.less';

.site-footer {
  background-color: @site-footer-bg;
  color: #ffffff;
}

.site-footer__inner {
  .site-container();
  padding-top: 64px;
  padding-bottom: 64px;
}

.site-footer__grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr 0.8fr 0.9fr 1.6fr;
  gap: 32px;
  margin-bottom: 48px;
}

.site-footer__col {
  text-align: left;
  min-width: 0;
}

.site-footer__title {
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
}

.site-footer__subgroup + .site-footer__subgroup {
  margin-top: 24px;
}

.site-footer__subtitle {
  margin-bottom: 8px;
  font-size: 12px;
  color: @site-gray-500;
  line-height: 18px;
}

.site-footer__list {
  li + li {
    margin-top: 8px;
  }
}

// 全局 common.css 有 `a { color:#232323 }`，这里必须用类选择器显式覆盖
.site-footer__link {
  font-size: 14px;
  color: @site-gray-400;
  line-height: 22px;
  transition: color 0.2s;

  &:hover {
    color: #ffffff;
  }
}

.site-footer__contact {
  margin-bottom: 16px;
}

.site-footer__contact-row {
  font-size: 14px;
  color: @site-gray-400;
  line-height: 22px;

  & + & {
    margin-top: 12px;
  }

  &--tel {
    font-size: 16px;
  }
}

.site-footer__contact-key {
  color: @site-gray-500;
}

.site-footer__tel {
  color: #ffffff;
  font-weight: 500;
}

.site-footer__qr {
  display: flex;
  gap: 12px;
  max-width: 280px;

  .site-footer__qr-item {
    flex: 1;
    min-width: 0;

    img {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 8px;
    }

    p {
      margin-top: 6px;
      font-size: 12px;
      color: @site-gray-400;
      line-height: 18px;
      text-align: center;
    }
  }
}

.site-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 原来是 nowrap + overflow:hidden + 固定 80px 高，右侧备案/许可证那串会被裁掉
  flex-wrap: wrap;
  gap: 12px 24px;
  padding-top: 32px;
  border-top: 1px solid rgba(55, 65, 81, 0.5);
  font-size: 14px;
  color: @site-gray-500;
  line-height: 22px;
}

.site-footer__bottom-left {
  color: @site-gray-500;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: #ffffff;
  }
}

.site-footer__bottom-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 20px;

  a {
    color: @site-gray-500;
    transition: color 0.2s;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>
